import { defineMessages } from 'react-intl-next';

export const messages: {
	designLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	designLabel: {
		id: 'design-search-result.label',
		defaultMessage: 'Design',
		description: 'Design search result label',
	},
});
